import { vuexBase } from '@/store/composition/base'

const createState = () => ({
  ...vuexBase.createState(),
  pagination: {
    pages: [],
    perPage: 1000,
    currentPage: 1
  },
  tableHeaders: [
    {
      title: 'Название',
      isSortable: true,
      sortName: 'name'
    }
  ]
})

const createGetters = () => ({
  ...vuexBase.createGetters(),

  getSearchValue: state => state.search,

  getList: state => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.name || '-'
        ]
      }
    })
  }
})

const createMutations = () => ({
  ...vuexBase.createMutations(),
  RESET_QUERY: state => {
    state.searchValue = ''
    state.sort = {}
    state.filter = {}
    state.pagination.currentPage = 1
  }
})

const vuexHandbookPage = {
  createState,
  createGetters,
  createMutations,
  createActions: vuexBase.createActions
}

export {
  vuexHandbookPage
}
